import { MapGroupUI, createMapGroupInstances } from "./mapgroupUI";
import { IMapGroupResponse, IMapData } from "../../interface";
import Axios from "axios";
import { Gamecloud } from "../../gamecloud";
import { Notification } from "../../../notification/notfication";

class MapGroup extends Gamecloud{

  private mapData: IMapGroupResponse | IMapData;
  private selectedGroup = null;
  private selectedMapsInGroup = null;

  public constructor(private ui: MapGroupUI) {
    super();
    this.getMapData();
  }

  /**
   * Fetch data from content
   */

  private getMapData() {

    if (typeof window.mapsData === 'undefined') {
      Axios.post(window.ajaxPath + '/getList/' + this.gameserverid, {}, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then((response) => {
        const data : IMapGroupResponse = response.data;
        this.mapData = data;
        this.selectedGroup = data.mapGroups.first;

        let i = 0;
        for (const key in data.mapGroups) {
          if (data.mapGroups.hasOwnProperty(key)) {
            const element = data.mapGroups[key];
            if (i === 0) {
              this.selectedGroup = element;
            }
          }
          i++;
        }
        this.ui.renderMapList(data.mapLists, this.onMapDrop.bind(this));
        this.ui.renderSelectedMaps(this.mapSelectedGroup());
        this.ui.renderSelect(data.mapGroups, this.afterRenderSelect.bind(this));
      }).catch((error) => {
        console.log(error);
      });
    } else {
      const data = window.mapsData;
      this.mapData = data;
      this.mapData.mapLists = data.maps;
      this.mapData.mapGroups = data.mapCycle;
      this.selectedGroup = data.mapCycle;

      this.ui.renderMapList(data.maps, this.onMapDrop.bind(this));
      this.ui.renderSelectedMaps(this.mapSelectedGroup());
      // this.ui.onDestroyButtonClick(this.onDestroyButtonClick.bind(this));
      this.ui.onSaveButtonClick(this.handleSaveButtonclick.bind(this));
    }
  }

  /**
   * Bind events after selectbox render
   */
  private afterRenderSelect() {
    this.ui.onMapGroupChange(this.onMapGroupChange.bind(this));
    this.ui.onCreateButtonClick(this.onCreateButtonClick.bind(this));
    this.ui.onAddMapGroupSubmit(this.handleSubmitNewMapGroup.bind(this));
    this.ui.onDestroyButtonClick(this.onDestroyButtonClick.bind(this));
    this.ui.onSaveButtonClick(this.handleSaveButtonclick.bind(this));
  }

  private handleSaveButtonclick() {
    this.loader.enable();
    this.ui.toggleSaveButton(true);
    if (typeof window.mapsData === 'undefined') {
      Axios.post(window.ajaxPath + '/setList/' + this.gameserverid, this.getMapGroupFormData(), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then((response) => {
        this.loader.disable();
        this.ui.toggleSaveButton(false);
        new Notification('success', 'Success', 'Your changes were saved');
      }).catch((error) => {
        this.loader.disable();
        this.ui.toggleSaveButton(false);
        new Notification('danger', 'Oops!', 'Something went wrong. Please try again later');
      });
    } else {
      Axios.post(window.ajaxPath + '/saveMapData/' + this.gameserverid, this.getMapFormData(), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then((response) => {
        new Notification('success', 'Success', 'Your changes were saved');
        this.ui.toggleSaveButton(false);
        this.loader.disable();
      }).catch(() => {
        new Notification('danger', 'Oops!', 'Something went wrong. Please try again later');
        this.ui.toggleSaveButton(false);
        this.loader.disable();
      })
    }
  }
  /**
   * Listen to mapgroup change
   * @param value
   */
  private onMapGroupChange(value: string) {
    for (const key in this.mapData.mapGroups) {
      if (this.mapData.mapGroups.hasOwnProperty(key)) {
        const element = this.mapData.mapGroups[key];
        if (key === value) {
          this.selectedGroup = element;
        }
      }
    }
    window.setTimeout(() => {
      if (this.ui.countMaps() < 1) {
        this.ui.showPlaceholder();
      }
    }, 100);
    this.ui.renderSelectedMaps(this.mapSelectedGroup());
  }

  /**
   * Handle drop event
   */
  private onMapDrop(evt) {
    window.setTimeout(() => {
      const selectedMapGroup = this.ui.getCurrentMapGroup();
      if (selectedMapGroup !== undefined) {
        this.mapData.mapGroups = { ...this.mapData.mapGroups, [selectedMapGroup]: this.ui.getSelectedMaps()};
      } else {
        this.mapData.mapGroups = this.ui.getSelectedMaps();
      }
    }, 100);
  }

  /**
   * Mapper to create a array with maps
   */
  private mapSelectedGroup() {
    const maps = [];
    this.selectedGroup.map((id: string) => {
      const map = this.mapData.mapLists.filter((item) => item.id === id);
      if (map.length > 0) {
        maps.push(map[0]);
      }
    });
    return maps;
  }

  /**
   * Handle destroy button click
   */
  private onDestroyButtonClick() {
    for (const key in this.mapData.mapGroups) {
      if (this.mapData.mapGroups.hasOwnProperty(key)) {
        const element = this.mapData.mapGroups[key];
        if (key === this.ui.getCurrentMapGroup()) {
          delete this.mapData.mapGroups[key];
        }
      }
    }

    let i = 0;
    for (const key in this.mapData.mapGroups) {
      if (this.mapData.mapGroups.hasOwnProperty(key)) {
        const element = this.mapData.mapGroups[key];
        if (i === 0) {
          this.selectedGroup = element;
        }
      }
      i++;
    }
    this.ui.renderSelectedMaps(this.mapSelectedGroup());
    this.ui.renderSelect(this.mapData.mapGroups, this.afterRenderSelect.bind(this));
  }

  private handleSubmitNewMapGroup(name: string) {
    this.mapData.mapGroups = {...this.mapData.mapGroups, [name]: new Array()}
    this.selectedGroup = [name];
    this.ui.renderSelect(this.mapData.mapGroups, this.afterRenderSelect.bind(this));
    this.ui.setValueOfMapGroupSelect(name);
    this.ui.renderSelectedMaps(this.mapSelectedGroup());
    this.ui.showPlaceholder();
  }

  /**
   * Handle create button click
   */
  private onCreateButtonClick() {
    this.ui.toggleAddMapGroupForm();
  }

  private getMapGroupFormData() {
    const bodyFormData = new FormData();
    for (let mapGroupKey in this.mapData.mapGroups) {
      if (this.mapData.mapGroups.hasOwnProperty(mapGroupKey)) {
        for (let mapItemKey in this.mapData.mapGroups[mapGroupKey]) {
          bodyFormData.append('MapGroups[' + mapGroupKey + '][]', this.mapData.mapGroups[mapGroupKey][mapItemKey]);
        }
      }
    }
    return bodyFormData;
  }

  private getMapFormData() {
    const bodyFormData = new FormData();
    for (let mapGroupp in this.mapData.mapGroups) {
      bodyFormData.append('MapCycle[]', this.mapData.mapGroups[mapGroupp]);
    }
    return bodyFormData;
  }
 }

export function initMapGroup() {
  return createMapGroupInstances().map((ui: MapGroupUI) => {
    return new MapGroup(ui);
  });
}
